import urlencode from 'urlencode'

const obj2QueryStr = (params) =>
	urlencode(JSON.stringify(params))

export default obj2QueryStr